var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm.isAuthenticated
        ? _c(
            "div",
            [
              _c("AppHeader"),
              _c("section", { staticClass: "main-menu navbar-space" }, [
                _c("div", { staticClass: "container" }, [
                  _vm._m(0),
                  _vm.taskHistoryList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "row justify-content-center" },
                        [
                          _c("div", { staticClass: "col-12 col-xs-fix" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "purchase-table-wrapper table-wrapper"
                              },
                              [
                                _c(
                                  "table",
                                  { staticClass: "purchase-table table" },
                                  [
                                    _vm._m(1),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.taskHistoryList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            key: item.requestId,
                                            staticClass: "main-row",
                                            attrs: { item: item, index: index }
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getTaskHistoryDetail(
                                                          item.requestId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "font",
                                                      {
                                                        attrs: {
                                                          color: "#008ec4"
                                                        }
                                                      },
                                                      [
                                                        _c("u", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.requestId
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "name-cell",
                                                attrs: { width: "150%" }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.reqTypeMapping(
                                                        item.reqType
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      item.contingentTypeNameTh
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "status-cell" },
                                              [
                                                item.status === "AP"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "status-wrapper status-success"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.statusDesc
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.status === "RJ"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "status-wrapper status-danger"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.statusDesc
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "date-cell" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.docCreateDate)
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "amt-cell" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "amt-cur" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatPrice(
                                                          item.lgAmt
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [_vm._v(_vm._s(item.beneNameTh))]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.requesterTaxId)
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.requesterNameTh)
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _vm._l(
                                                  item.taskRequesterVoList,
                                                  function(r) {
                                                    return [
                                                      _vm._v(
                                                        "\n                     " +
                                                          _vm._s(
                                                            r.guaranteeTaxId
                                                          ) +
                                                          ",\n                    "
                                                      )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [
                                                _vm._l(
                                                  item.taskRequesterVoList,
                                                  function(r) {
                                                    return [
                                                      _vm._v(
                                                        "\n                     " +
                                                          _vm._s(
                                                            r.guaranteeName
                                                          ) +
                                                          ",\n                    "
                                                      )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "name-cell" },
                                              [_vm._v(_vm._s(item.commNo))]
                                            ),
                                            _c("td")
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _c("b-pagination", {
                            attrs: {
                              size: "md",
                              "total-rows": _vm.totalRecord,
                              "per-page": 10
                            },
                            on: {
                              input: function($event) {
                                return _vm.getTaskHistoryList(_vm.currentPage)
                              }
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.taskHistoryList.length === 0
                    ? _c("div", { staticClass: "row justify-content-center" }, [
                        _vm._m(2)
                      ])
                    : _vm._e()
                ])
              ]),
              _c("AppFooter")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "secondary-title" }, [
          _c("h5", { staticClass: "title" }, [
            _vm._v("ประวัติยืนยันการอนุมัติให้ใช้วงเงินและหักค่าธรรมเนียม")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("หมายเลขอ้างอิงรายการ")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ประเภทธุรกรรม")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ประเภทการค้ำประกัน")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("สถานะ")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("วันที่ทำรายการ")]),
        _c("th", { staticClass: "amt-th", attrs: { scope: "col" } }, [
          _vm._v("วงเงินค้ำประกัน(บาท)")
        ]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ชื่อผู้รับผลประโยชน์")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Tax Id ผู้ขอออก")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ชื่อผู้ขอออก")]),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("Tax Id ผู้ค้ำประกันในนาม")
        ]),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("ชื่อผู้ค้ำประกันในนาม")
        ]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("หมายเลขบัญชีวงเงิน")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-xs-fix" }, [
      _c("div", { staticClass: "purchase-table-wrapper table-wrapper" }, [
        _c("table", { staticClass: "purchase-table table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("หมายเลขอ้างอิงรายการ")
              ]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("ประเภทรายการ")]),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("ประเภทการค้ำประกัน")
              ]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("สถานะ")]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("วันที่ทำรายการ")]),
              _c("th", { staticClass: "amt-th", attrs: { scope: "col" } }, [
                _vm._v("จำนวนเงินค้ำประกัน(บาท)")
              ]),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("ชื่อผู้รับผลประโยชน์")
              ]),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("Tax Id ผู้ขอออก")
              ]),
              _c("th", { attrs: { scope: "col" } }, [_vm._v("ชื่อผู้ขอออก")]),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("Tax Id ผู้ค้ำประกันในนาม")
              ]),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("ชื่อผู้ค้ำประกันในนาม")
              ]),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("หมายเลขบัญชีวงเงิน")
              ]),
              _c("th")
            ])
          ]),
          _c("tbody", [
            _c("tr", { staticClass: "empty-data" }, [
              _c("td", { attrs: { colspan: "999" } }, [_vm._v("ไม่มีข้อมูล")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }